import { SW_SOURCE } from "app/pages/activation/components/GAWidget/widgetsConfig";
import { ACTIVATION_API } from "app/pages/activation/services/constants";
import type { FirstPartyDataSource, GADataSchema } from "app/pages/activation/types/api";
import type { IFetchService } from "app/services/fetchService";
import type { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

type GAApiServiceSchema = {
    getGAData(
        activationObjectId: string,
        granularity: GranularityNames,
        source: FirstPartyDataSource,
    ): Promise<GADataSchema | null>;
};

export const gaApiService = (fetchService: IFetchService): GAApiServiceSchema => ({
    getGAData: async (activationObjectId: string, granularity: GranularityNames, source: FirstPartyDataSource) => {
        return await fetchService.get(`${ACTIVATION_API}/${activationObjectId}/ga/data`, {
            granularity,
            useSwData: source === SW_SOURCE,
        });
    },
});
